module.exports = __webpack_public_path__ + "static/media/ember.b56790ca.svg";